import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Brain, Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Progress of Fidem's analysis of every judge in the country; admins can launch it all at once
export const ProfileBatchBar = ({ isAdmin }) => {
  const { api } = useAuth();
  const [s, setS] = useState(null);
  const load = () => api.get('/courts/profiles/batch').then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!s?.running) return undefined;
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [s?.running]); // eslint-disable-line react-hooks/exhaustive-deps
  const start = async () => {
    try { const r = await api.post('/courts/profiles/batch'); setS({ ...r.data, running: true }); toast.success('Fidem comenzó a analizar a todos los magistrados'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Solo un administrador puede iniciarlo'); }
  };
  if (!s) return null;
  const pct = s.total_judges ? Math.round((s.profiled / s.total_judges) * 100) : 0;
  return (
    <div data-testid="profile-batch-bar" className="mt-4 flex flex-wrap items-center gap-3 rounded-2xl border border-emerald-500/30 bg-emerald-500/5 px-4 py-3">
      <Brain className="h-4 w-4 text-emerald-300" />
      <div className="min-w-[200px] flex-1">
        <p data-testid="profile-batch-count" className="text-xs text-emerald-100">Fidem analizó {s.profiled} de {s.total_judges} magistrados ({pct}%){s.running ? ' · analizando ahora...' : ''}{!s.running && s.aborted ? ` · pausado: ${s.aborted}` : ''} · aprende de tus resultados y simulaciones cada noche</p>
        <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-slate-800"><div className="h-full rounded-full bg-emerald-400 transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
      </div>
      {isAdmin && s.pending > 0 && (
        <button data-testid="profile-batch-start" onClick={start} disabled={s.running} className="flex items-center gap-1 rounded-full bg-emerald-500 px-3 py-1.5 text-xs font-semibold text-slate-950 disabled:opacity-60">
          {s.running ? <><Loader2 className="h-3.5 w-3.5 animate-spin" />En curso</> : `Analizar los ${s.pending} pendientes ahora`}
        </button>
      )}
    </div>
  );
};
